import type { HelpFile } from '../../types/help'
import { FunctionGroupsTestIds } from '../../../testids/FunctionGroupsTestIds'

export const functionGroupsHelp: HelpFile = {
  docPage: '/docs/governance/function-groups',
  texts: {
    [FunctionGroupsTestIds.functionGroupsList]:
      'All function groups defined across the platform. Each group bundles access profiles into a reusable, business-meaningful role that can be requested and certified together.',
    [FunctionGroupsTestIds.btnNewFunctionGroup]:
      'Create a new function group. The type drives which attributes and policies apply.',
    [FunctionGroupsTestIds.colName]: null,
    [FunctionGroupsTestIds.colOwner]: null,
    [FunctionGroupsTestIds.colType]: null,
  },
}
